<template>
  <div class="card">
    <div class="card-header">
      <span
        v-if="submitForm === true"
        class="submitForm"
      >
        Thank you for your submission. If you indicated interest, a missionary will be in contact with you soon!
      </span>
      <h4 class="title">
        Interest Questionnaire
      </h4>
      <h5 style="font-size:14px;">
        Please fill out this form to learn more about Catholic campus ministry activities available to students.
      </h5>
      <span v-if="validationError === true" style="color: red;">
        Missing fields.
        <p>Please make sure the starred fields are filled out.</p>
      </span>
      <span v-if="emailError === true" style="color: red;">
        <p>Please make sure the email address you entered is valid.</p>
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <label>First Name<b>*</b></label>
          <fg-input
            type="text"
            placeholder="First Name"
            v-model="first_name"
          />
        </div>
        <div class="col-md-6">
          <label>Last Name<b>*</b></label>
          <fg-input
            type="text"
            placeholder="Last Name"
            v-model="last_name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>Phone<b>*</b></label>
          <fg-input
            type="text"
            placeholder="Cell Phone Number"
            v-model="phone"
          />
        </div>
        <div class="col-md-6">
          <label>Email Address</label>
          <fg-input
            type="text"
            placeholder="Email"
            v-model="email"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="control-label">Gender<b>*</b></label>
          <el-select
            placeholder="Gender"
            size="large"
            class="select-default"
            v-model="gender_id"
          >
            <el-option
              v-for="genderOption in genderOptions"
              class="select-default"
              :key="genderOption.id"
              :label="genderOption.name"
              :value="genderOption.id"
            />
          </el-select>
        </div>
        <div
          class="col-md-6"
        >
          <label class="control-label">School Year<b>*</b></label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="School Year"
              v-model="school_year_id"
            >
              <el-option
                v-for="schoolYearOption in schoolYearOptions"
                class="select-default"
                :key="schoolYearOption.id"
                :label="schoolYearOption.name"
                :value="schoolYearOption.id"
              />
            </el-select>
          </fg-input>
        </div>
      </div>
      <div
        class="row"
      >
        <div class="col-sm-6">
          <label>Do you play a varsity sport?<b>*</b></label>
          <p-radio
            v-model="is_varsity"
            :value="1"
            :label="true"
          >
            Yes
          </p-radio>
          <p-radio
            v-model="is_varsity"
            :value="0"
            :label="false"
          >
            No
          </p-radio>
        </div>
        <div class="col-sm-6">
          <label>Are you in a fraternity or sorority?<b>*</b></label>
          <p-radio
            v-model="is_greek"
            :value="1"
            :label="true"
          >
            Yes
          </p-radio>
          <p-radio
            v-model="is_greek"
            :value="0"
            :label="false"
          >
            No
          </p-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <label>Are you interested in hearing about Catholic campus ministry events?<b>*</b></label>
          <p-radio
            v-model="has_general_interest"
            :value="1"
            :label="true"
          >
            Yes
          </p-radio>
          <p-radio
            v-model="has_general_interest"
            :value="0"
            :label="false"
          >
            No
          </p-radio>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <label>Are you interested in joining a Bible study?</label>
          <p-radio
            v-model="has_bible_study_interest"
            :value="1"
            :label="true"
          >
            Yes
          </p-radio>
          <p-radio
            v-model="has_bible_study_interest"
            :value="0"
            :label="false"
          >
            No
          </p-radio>
        </div>
        <div
          class="col-sm-6"
          id="bibleStudyDays"
        >
          <label>What days would you be available?</label>
          <div
            class="form-group form-check"
            v-for="day in days_of_week"
            :key="day.id"
          >
            <p-checkbox
              v-model="bible_study_days[day.id]"
              :id="day.name"
              :value="day.id"
              :label="day.name"
            >
              {{ day.name }}
            </p-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <label>We can contact you via...</label>
          <br>
          <div class="form-group form-check" v-for="option in opt_in_options" :key="option.id">
            <p-checkbox
              v-model="opt_in[option.name]"
              :id="option.name"
              :value="option.name"
              :label="option.title"
            >
              {{ option.title }}
            </p-checkbox>
          </div>
        </div>
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          v-if="!saving"
          @click="handleSave()"
        >
          Save
        </button>
        <button type="submit" class="btn btn-info btn-fill btn-wd" v-if="saving">
          Saving...
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
    DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option
} from 'element-ui';
import axios from 'axios';

function validateForm(firstName, lastName, genderId, schoolYearId, isVarsity, isGreek,
    phoneNum, isContact) {
    return !!firstName && !!lastName && !!genderId && !!schoolYearId && isVarsity !== '' && isGreek !== ''
    && !!phoneNum && isContact !== '';
}

export default {
    data() {
        return {
            appUrl: process.env.VUE_APP_API_URL,
            namespace: 'People',
            first_name: '',
            last_name: '',
            email: '',
            phone: '',
            is_varsity: '',
            is_greek: '',
            has_general_interest: '',
            has_bible_study_interest: '',
            validationError: false,
            submitForm: false,
            emailError: false,
            saving: false,
            schoolYearOptions: [],
            genderOptions: [],
            gender_id: '',
            school_year_id: '',
            bible_study_days: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
                6: false
            },
            opt_in: {
                text: false,
                email: false
            },
            opt_in_options: [
                {
                    title: 'Text Message',
                    name: 'text',
                    id: 0
                },
                {
                    title: 'Email Address',
                    name: 'email',
                    id: 1
                }
            ],
            days_of_week: [
                {
                    name: 'Sunday',
                    id: 0
                },
                {
                    name: 'Monday',
                    id: 1
                },
                {
                    name: 'Tuesday',
                    id: 2
                },
                {
                    name: 'Wednesday',
                    id: 3
                },
                {
                    name: 'Thursday',
                    id: 4
                },
                {
                    name: 'Friday',
                    id: 5
                },
                {
                    name: 'Saturday',
                    id: 6
                },
            ]
        };
    },
    props: {
    },
    methods: {
        handleSave() {
            window.scrollTo(0, 0);
            this.saving = true;
            this.validationError = false;
            this.emailError = false;
            if (!validateForm(this.first_name, this.last_name, this.gender_id,
                this.school_year_id, this.is_varsity, this.is_greek, this.phone,
                this.has_general_interest)) {
                this.validationError = true;
                this.saving = false;
                this.submitForm = false;
                return;
            }
            // Call backend to actually make person and interest record
            // We call it like this because we are calling a public endpoint
            // and not passing in a token
            axios.post(`${this.appUrl}/registration`, {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email ? this.email.toLowerCase() : '',
                phone: this.phone,
                gender_id: this.gender_id,
                school_year_id: this.school_year_id,
                is_varsity: this.is_varsity,
                is_greek: this.is_greek,
                has_general_interest: this.has_general_interest,
                opt_in: this.opt_in,
                has_bible_study_interest: this.has_bible_study_interest,
                bible_study_days: this.bible_study_days,
                // eslint-disable-next-line radix
                location_id: parseInt(this.$route.params.id)
            })
                .then((interestRecordId) => {
                    this.saving = false;
                    this.submitForm = true;
                    // clear all fields
                    this.first_name = '';
                    this.last_name = '';
                    this.email = '';
                    this.phone = '';
                    this.gender_id = '';
                    this.school_year_id = '';
                    this.is_varsity = '';
                    this.is_greek = '';
                    this.has_general_interest = '';
                    this.opt_in = {
                        text: false,
                        email: false
                    };
                    this.has_bible_study_interest = '';
                    this.bible_study_days = [];
                    document.getElementById('bibleStudyDays').style.display = 'none';
                }).catch((error) => {
                    this.error = error;
                    this.saving = false;
                    // handle special logic for invalid email error
                    if (error.response.data.message === 'Invalid email') {
                        this.emailError = true;
                    } else {
                    // else alert user of any other error
                        this.$message(error.response.data.message);
                    }
                });
        },
        getSchoolYears() {
            axios.get(`${this.appUrl}/schoolYears`)
                .then((response) => {
                    this.schoolYearOptions = response.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        getGenders() {
            axios.get(`${this.appUrl}/genders`)
                .then((response) => {
                    this.genderOptions = response.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
    },
    watch: {
        // When someone changes their answer to bible study interest,
        // this will change if Bible study availability shows
        has_bible_study_interest(value) {
            const bibleStudyDays = document.getElementById('bibleStudyDays');
            if (value === true) {
                bibleStudyDays.style.display = 'block';
            } else if (value === false || value === null) {
                bibleStudyDays.style.display = 'none';
            }
        }
    },
    created() {
        this.getSchoolYears();
        this.getGenders();
    }
};
</script>
<style scoped>
#bibleStudyDays {
  display:none;
}
b {
  color:red;
}
.submitForm {
  color: white;
  background-color: #838383;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:45px;
  font-size:19px;
  border-bottom:3px solid black;
  font-style: italic;
  padding-top: 6px;
}
@media only screen and (min-width: 473px) and (max-width: 1367px) {
    .submitForm {
    font-size:17px;
    height: 60px;
  }
}
@media only screen and (max-width: 473px) {
  .submitForm {
    font-size:13px;
    height: 60px;
  }
}
</style>
